/**
 * Teacher-only train geometry. The *same* wagon/engine size is used for all
 * 1–6 letter targets at a given viewport; longer targets use extra rows.
 * Never shrink the classroom letters merely to fit six onto a phone.
 */
export const MAX_CLASSROOM_TRAIN_COLUMNS = 6;

const clamp = (minimum, value, maximum) => Math.min(maximum, Math.max(minimum, value));

export function classroomTrainLayout(width, height, targetLength = 6) {
  const available = Math.max(200, Number(width) || 0);
  const viewportHeight = Math.max(400, Number(height) || 0);
  const mobile = available < 700;
  // The stage has inline padding; reserve room for it rather than relying on
  // flex-shrink, which used to give different wagon sizes to short words.
  const inner = Math.max(180, available - (mobile ? 24 : 16));
  const gap = mobile ? 10 : clamp(12, available * .012, 20);
  const engineRatio = mobile ? 1.4 : 1.24;
  const minimum = available < 450 ? 82 : mobile ? 88 : available < 900 ? 96 : 110;
  const maximum = mobile ? 110 : available < 900 ? 170 : 220;
  const fit = count => (inner - count * gap) / (count + engineRatio);

  let columns = MAX_CLASSROOM_TRAIN_COLUMNS;
  while (columns > 1 && fit(columns) < minimum) columns -= 1;
  const rows = Math.ceil(Math.max(1, targetLength) / columns);
  // Apply the *same* height constraint to every word length. An 11-letter
  // word gains a second row; it must not cause a different-sized locomotive.
  // Taller boards allow larger artwork without pushing audio/tiles below the bezel.
  const heightCap = clamp(mobile ? 88 : 110, viewportHeight * .24, maximum);
  const wagonWidth = Math.round(Math.max(64, Math.min(maximum, heightCap, fit(columns))));
  const engineWidth = Math.round(wagonWidth * engineRatio);
  const wagonHeight = Math.round(Math.max(mobile ? 88 : 92, wagonWidth * .77));

  return { columns, rows, wagonWidth, wagonHeight, engineWidth, gap };
}
